import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 650px;
  max-height: 650px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const Left = styled.div`
  width: 100%;
  max-width: 200px;
  height: 650px;
  max-height: 650px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};
  border-right: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  overflow: auto;

  .textTitle {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    margin-bottom: 6px;
  }
`;

interface ISection {
  isactive?: boolean;
  isdisabled?: boolean;
}

export const LeftTitle = styled.div<ISection>`
  width: 100%;
  height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 6px;
  padding: 0 6px 0 4px;
  cursor: pointer;

  &+& {
    margin-top: 4px;
  }

  .iconTitle {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  .title {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 6px;
    white-space: nowrap;
  }

  ${({ isactive, theme }) => isactive && css`
    background-color: ${`color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.surface.surface})`};

    .iconTitle {
      color: ${theme.colors.primary.primary} !important;
    }

    .title {
      color: ${theme.colors.primary.primary};
    }
  `}

  ${({ isdisabled, theme }) => isdisabled && css`
    cursor: not-allowed;

    .iconTitle {
      color: ${theme.colors.surface.onSurfacePlaceholder} !important;
    }

    .title {
      color: ${theme.colors.surface.onSurfacePlaceholder};
    }
  `}

  .badgeUpdate {
    height: 16px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
    padding: 2px 4px;
    margin-left: 8px;
    
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    text-overflow: ellipsis;
  }
`;

export const Hr = styled.hr`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  margin: 6px 0;
`;

export const Main = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`;

export const MainContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface IMainContentTop {
  hasfooter?: boolean;
}

export const MainContentTop = styled.div<IMainContentTop>`
  width: 100%;
  height: 100%;
  max-height: ${({ hasfooter }) => hasfooter ? '576px' : '632px'};
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`;

export const Footer = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};

  .btnFooter {
    height: 32px !important;
    display: flex;
    align-items: center;

    .textBtn {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.primary.onPrimary};
    }
  }
`;
